// DIO Content Configuration
// Quotes from JoJo's Bizarre Adventure

const dioQuotes = [
  "You thought your first kiss would be JoJo, but it was me, Dio!",
  "ZA WARUDO! Time has stopped!",
  "MUDA MUDA MUDA MUDA!",
  "I reject my humanity, JoJo!",
  "How many breads have you eaten in your life?",
  "WRYYYYY!",
  "Do you believe in gravity?",
  "I, Dio, have a dream!",
  "You cannot escape from heaven!",
  "This is the greatest high! JOJO!",
  "Your face when you're flustered... is the ultimate kick!",
  "Useless, useless, useless!",
  "I'll smash you flat!",
  "Road Roller da!",
  "Immortality! Eternal life! And STAND POWER!",
  "I feel a feeling of power flowing through me!",
  "Weakling! Weakling!",
  "You're next, Jotaro!",
  "The World is the ultimate Stand!",
  "Even Speedwagon is afraid!",
  "Goodbye, JoJo!",
  "You bastard! DIO!",
  "Poor, poor Dario's son... But I... I can overcome it!",
  "I wanted to be a true gentleman... But I suppose I'll be content with power!",
  "Space Ripper Stingy Eyes!",
  "Being a vampire is the ultimate evolution!",
  "Kneel before my power!",
  "Nothing can match the power of The World!",
  "One second has passed...",
  "Sono chi no sadame... JOJO!"
];

module.exports = {
  dioQuotes
};
